const PROBLEM_LABELS = {
  client_absent: 'Client absent',
  wrong_address: 'Mauvaise adresse',
  refusal: 'Refus',
  damaged: 'Endommagé',
  other: 'Autre',
};

/**
 * Problem type breakdown as horizontal CSS bars
 * @param {{ problems: Record<string, number> }} props
 */
export default function ProblemChart({ problems }) {
  const entries = Object.entries(problems || {});

  if (entries.length === 0) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h3 className="font-semibold mb-2">Problèmes par type</h3>
        <p className="text-sm text-gray-500">Aucun problème signalé.</p>
      </div>
    );
  }

  const max = Math.max(...entries.map(([, v]) => v), 1);
  const total = entries.reduce((sum, [, v]) => sum + v, 0);

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h3 className="font-semibold mb-1">Problèmes par type</h3>
      <p className="text-xs text-gray-500 mb-4">{total} problèmes au total</p>

      <div className="space-y-3">
        {entries.map(([type, count]) => (
          <div key={type}>
            <div className="flex justify-between text-sm mb-1">
              <span>{PROBLEM_LABELS[type] || type}</span>
              <span className="font-medium">{count}</span>
            </div>
            <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-red-500 rounded-full transition-all duration-300"
                style={{ width: `${(count / max) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
